// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pg-65","newExpiryDate":"styles_newExpiryDate__3Ph6z","footer":"styles_footer__EtKc0"};